export default __webpack_public_path__ + "static/media/inside-look-mob.ca12fc90.png";